// extracted by mini-css-extract-plugin
export default {"color-salmon":"#F5B9A1","colorSalmon":"#F5B9A1","promoArea":"mVHPU AgyN9","promoIcon":"fyac1","promoText":"m1IVA a8cCT x25tu","promoTCsIcon":"JirNY","promoTCs":"D4wGe"};